<template>
  <div>
    <b-card>
      <b-row class="mb-3">
        <b-col>
          <b-form-group label="از تاریخ">
            <date-picker v-model="datefrom" clearable></date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="تا تاریخ">
            <date-picker v-model="dateto" clearable></date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button @click="refresh()" class="btn btn-success mt-9">بروزرسانی</b-button>
        </b-col>
      </b-row>
      <b-tabs>
        <b-tab title="روزانه">
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyRialGateway"
                title="درخواست های درگاه ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyDollarGateway"
                title="درخواست های درگاه دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyRialTransaction"
                title="تعداد تراکنش های ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyDollarTransaction"
                title="تعداد تراکنش های دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'sum' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyRialTransaction"
                title="مبلغ تراکنش های ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'sum' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyDollarTransaction"
                title="مبلغ تراکنش های دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyshare"
                title="تسویه های تسهیمی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.dailyRegister"
                title="تعداد ثبت نامی ها"
              >
              </chartComponent>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="ماهانه">
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyRialGateway"
                title="درخواست های درگاه ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyDollarGateway"
                title="درخواست های درگاه دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyRialTransaction"
                title="تعداد تراکنش های ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'تعداد', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyDollarTransaction"
                title="تعداد تراکنش های دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'sum' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyRialTransaction"
                title="مبلغ تراکنش های ریالی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'sum' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyDollarTransaction"
                title="مبلغ تراکنش های دلاری"
              >
              </chartComponent>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyshare"
                title="تسویه های تسهیمی"
              >
              </chartComponent>
            </b-col>
            <b-col>
              <chartComponent
                :xyfiellds="{
                  y: { name: 'مبلغ', column: 'count' },
                  x: { name: 'روز', column: 'date' },
                }"
                :charttype="'line'"
                :url="url.monthlyRegister"
                title="تعداد ثبت نامی ها"
              >
              </chartComponent>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import moment from "jalali-moment";
import chartComponent from "../../components/ChartComponent/Chart.vue";
export default {
  name: "reports",
  data() {
    return {
      datefrom: moment().add(-15, "days").format("jYYYY/jMM/jDD"),
      dateto: moment().format("jYYYY/jMM/jDD"),
      url: {
        dailyRialGateway: "",
        dailyDollarGateway: "",
        dailyRialTransaction: "",
        dailyDollarTransaction: "",
        dailyshare: "",
        dailyRegister: "",

        monthlyRialGateway: "",
        monthlyDollarGateway: "",
        monthlyRialTransaction: "",
        monthlyDollarTransaction: "",
        monthlyshare: "",
        monthlyRegister: "",
      },
    };
  },
  components: { chartComponent: chartComponent },
  mounted() {
    this.url.dailyRialGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=483`;
    this.url.dailyDollarGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=1722`;
    this.url.dailyRialTransaction = `~transaction/charts/TransactionCount?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=483`;
    this.url.dailyDollarTransaction = `~transaction/charts/TransactionCount?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=1722`;
    this.url.dailyshare = `share/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily`;
    this.url.dailyRegister = `charts/registers?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&sumOrCount=count`;

    this.url.monthlyRialGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&rialOrDollar=483`;
    this.url.monthlyDollarGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&rialOrDollar=1722`;
    this.url.monthlyRialTransaction = `~transaction/charts/monthly?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=483`;
    this.url.monthlyDollarTransaction = `~transaction/charts/monthly?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=1722`;
    this.url.monthlyshare = `share/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly`;
    this.url.monthlyRegister = `charts/registers?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&sumOrCount=count`;
  },
  methods: {
    refresh() {
      this.url.dailyRialGateway = "";
      this.url.dailyDollarGateway = "";
      this.url.dailyRialTransaction = "";
      this.url.dailyDollarTransaction = "";
      this.url.dailyshare = "";
      this.url.dailyRegister = "";

      this.url.monthlyRialGateway = "";
      this.url.monthlyDollarGateway = "";
      this.url.monthlyRialTransaction = "";
      this.url.monthlyDollarTransaction = "";
      this.url.monthlyshare = "";
      this.url.monthlyRegister = "";

      this.url.dailyRialGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=483`;
      this.url.dailyDollarGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=1722`;
      this.url.dailyRialTransaction = `~transaction/charts/TransactionCount?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=483`;
      this.url.dailyDollarTransaction = `~transaction/charts/TransactionCount?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=1722`;
      this.url.dailyshare = `share/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily`;
      this.url.dailyRegister = `charts/registers?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&sumOrCount=count`;

      this.url.monthlyRialGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&rialOrDollar=483`;
      this.url.monthlyDollarGateway = `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&rialOrDollar=1722`;
      this.url.monthlyRialTransaction = `~transaction/charts/monthly?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=483`;
      this.url.monthlyDollarTransaction = `~transaction/charts/monthly?datefrom=${this.datefrom}&dateto=${this.dateto}&rialOrDollar=1722`;
      this.url.monthlyshare = `share/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly`;
      this.url.monthlyRegister = `charts/registers?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=monthly&sumOrCount=count`;
    },
    // refresh() {
    //   this.getDayly_ChartDataGatewayRial();
    //   this.getDayly_ChartDataGatewayDollar();
    // },
    // getDayly_ChartDataGatewayRial() {
    //   httpHelper
    //     .getData(
    //       `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=483`
    //     )
    //     .then((res) => {
    //       if (res.success) {
    //         this.ChartDataGatewayRial = res.result;
    //       }
    //     });
    // },
    // getDayly_ChartDataGatewayDollar() {
    //   httpHelper
    //     .getData(
    //       `payment-gateway/chart?dateFrom=${this.datefrom}&dateTo=${this.dateto}&type=daily&rialOrDollar=1722`
    //     )
    //     .then((res) => {
    //       if (res.success) {
    //         this.ChartDataGatewayDollar = res.result;
    //       }
    //     });
    // },
  },
};
</script>